import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import initDom from "./mixins/init_dom";
import ShopMainContent from "./components/shop/ShopMainContent";
import Products from "./components/shop/products/Products";
import URLParamString from "./mixins/url";
import { mapGetters, mapMutations, mapActions } from "vuex";

autoload();

window.app = new Vue({
  el: "#vue-coatings",

  mixins: [initDom, auth, cart, URLParamString],

  components: {
    ShopMainContent,
    Products,
  },

  data() {
    return {
      starterProducts: window._PR?.starterProducts?.data || [],
      proKits: window._PR?.products?.data || [],
      lockedTitle: "",
      lockedMessage: "",
    };
  },

  computed: {
    ...mapGetters([
      "infiniteId",
      "products",
      "selectedCollectionCategory",
      "message",
      "searchText",
    ]),

    hasSelectedParentCollection() {
      if (Object.keys(this.selectedCollectionCategory)) return false;

      const parentCollection =
        this.selectedCollectionCategory.parent_category_refs;

      if (
        parentCollection.length &&
        parentCollection[0].name === "Collections"
      ) {
        return true;
      }

      return false;
    },

    activeSubCollections() {
      if (Object.keys(this.selectedCollectionCategory)) return false;

      const parentCategory =
        this.selectedCollectionCategory.parent_category_refs;
      const subCategory = this.selectedCollectionCategory.sub_categories;

      if (parentCategory.length) {
        return parentCategory[0].name === "Collections"
          ? subCategory.filter((active) => {
              return active.enabled;
            })
          : [];
      }

      return [];
    },

    // Still needed for other shop pages (i.e. Swatch Sets, Kits, etc.)
    searchTextModel: {
      get() {
        return this.searchText;
      },
      set(value) {
        this.setSearchText(value);
      },
    },
  },

  mounted() {
    $(window).on("resize load", this.adjustFilterOffsetsAndSizes);
    $(window).trigger("resize");

    this.$on("color-filter-updated", this.resetLoading);
  },

  methods: {
    ...mapMutations(["setSearchText"]),

    ...mapActions([
      "searchShop",
      "resetFilters",
      "renderProducts",
      "resetLoading",
    ]),

    adjustFilterOffsetsAndSizes() {
      const windowWidth = $(window).width();
      const fixOnScroll = false;
      const clampHeight = fixOnScroll;
      const maxHeight = 680;
      const maxWidth = 1013;
      const adjustedFilterHeight = 205;
      let filterOffset = 270;

      if (windowWidth < 1200 && windowWidth > 1069) {
        filterOffset = 350;
      }

      if (windowWidth < 1070) {
        filterOffset = 395;
      }

      if (windowWidth >= maxWidth) {
        $("aside .side-box").css("height", "auto");
        $("aside .side-box").css("overflow-y", "auto");

        if (clampHeight) {
          if ($(window).height() <= maxHeight) {
            let heightNum = $(window).height() - adjustedFilterHeight;
            $("aside .side-box").css("max-height", heightNum);
          } else {
            $("aside .side-box").css("max-height", "560px");
          }
        } else {
          $("aside .side-box").css("max-height", "");
        }

        $(window).scroll(function () {
          if (fixOnScroll) {
            if (
              $(window).scrollTop() >= filterOffset &&
              windowWidth > maxWidth
            ) {
              let topNum = $(window).scrollTop() - filterOffset;
              $(".products-filtered aside").css("top", topNum);
            } else {
              $("aside").css("top", "0px");
            }
          } else {
            $("aside").css("top", "0px");
          }
        });
      }

      $(window).scroll(function () {
        if ($(window).scrollTop() >= 310) {
          $(".products-filtered .back-to-top").css("display", "inline");
        } else {
          $(".products-filtered .back-to-top").css("display", "none");
        }
      });
    },

    onInfinite($state) {
      this.renderProducts()
        .then((response) => {
          $state[response]();
        })
        .catch((error) => console.error(error));
    },

    gtmProductClick(product, productType, index) {
      let vm = this;

      window.dataLayer.push({
        event: "productClick",
        ecommerce: {
          click: {
            products: [
              {
                name: product.name,
                id: product.sku,
                price: product.pricing[0].price_per_base_quantity.amount,
                brand: "Cerakote",
                category: productType,
                position: index,
              },
            ],
          },
        },
      });

      // this is for GA4
      window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          item_list_id: undefined,
          item_list_name: undefined,
          currency: "USD",
          value: undefined,
          items: [
            {
              item_id: product.sku,
              item_name: product.name,
              affiliation: vm.me.customer_id ? vm.me.customer_id : undefined,
              coupon: undefined,
              currency: "USD",
              discount:  undefined,
              index: index,
              item_brand: "Cerakote",
              item_category: product.base_quantity.unit,
              item_list_id: undefined,
              item_list_name: undefined,
              item_variant: undefined,
              location_id: "Shop Collection",
              price: parseFloat(
                product.pricing[0].price_per_base_quantity.amount
              ),
              quantity: 1,
            },
          ],
        },
      });
    },
  },
});

// displays the add-to-cart dropdown
require("./app_events");
